var render = function render(){var _vm=this,_c=_vm._self._c;return _c('create-folder',{attrs:{"tool":_vm.module}})
}
var staticRenderFns = []

export { render, staticRenderFns }